import axios, { AxiosError } from "axios"
import {
  MASSIVE_PATH,
  MODULE_PATH,
  USER_MODULE_PATH,
} from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getUserModulesByModuleIdService = async (id: number) => {
  try {
    const result = await instance.get(MODULE_PATH + "/" + id + USER_MODULE_PATH)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}

export const createUserModulesMassiveService = async (userModules: any) => {
  try {
    const result = await instance.post(
      USER_MODULE_PATH + MASSIVE_PATH,
      userModules
    )
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
